import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import DetailWrapper from '../../../sharedcomponents/4layouts/DetailWrapper'
import useDetailEditMode from '../../../sharedcomponents/4layouts/useDetailEditMode'
import LeftCard from '../../../sharedcomponents/5templates/detailCards/leftCard'
import ListBucketCard from '../../../sharedcomponents/5templates/detailCards/listBucketCard'
import useParty from './useParty'
import UserLeftChild from './UserLeftChild'
import PeopleLeftChild from './PeopleLeftChild'

const UserDetail = ({ createMode, type: initialType }) => {
  const { partyId } = useParams()
  const [type, setType] = useState(initialType)
  const [isGuest, setIsGuest] = useState(false)

  // This is a horrible state to have. Mostly because the
  // previous dev made a mess of the state in all of these
  // compontents.
  const [isTypeLoaded, setIsTypeLoaded] = useState(false)

  const { detailEditMode, setDetailEditMode } = useDetailEditMode(createMode)
  const [centerCardDisabled, setCenterCardDisabled] = useState(type === 'user')
  const [rightCardDisabled, setRightCardDisabled] = useState(type === 'contact')

  const isUserType = useMemo(() => type === 'user', [type]);

  const {
    typeIdToDisplayName,
    useGetOneFatPartyQuery,
    fetchAuxiliaryRecords,
    bulkUpdateParties,
    upsertPartyCallback,
    resourceTypes,
    finalAuxiliaryRecords,
    makeInMemoryPartyRecord,
    removeParty,
    removeUser,
    loading: updatePeopleLoading
  } = useParty()

  const {
    data: { data: rawUserRecord } = {
      data: {}
    },
    refetch,
    isLoading,
    isSuccess
  } = useGetOneFatPartyQuery(
    {
      include: ['counts'],
      id: partyId
    },
    { skip: createMode, refetchOnMountOrArgChange: true }
  )

  const loading = useMemo(() => updatePeopleLoading || isLoading, [updatePeopleLoading, isLoading])

  const primaryPartyRecord = createMode
    ? makeInMemoryPartyRecord(type)
    : JSON.parse(JSON.stringify(rawUserRecord))
  primaryPartyRecord.refetch = refetch
  primaryPartyRecord.type = primaryPartyRecord?._has_user_account ? 'user' : 'contact'
  primaryPartyRecord.assertGuest = primaryPartyRecord?.user?.allow_otp

  const activateType = useCallback((newType, newIsGuest) => {
    if (newType === 'user') {
      setType('user')
      setCenterCardDisabled(true)
      setRightCardDisabled(false)

    } else if (newType === 'contact') {
      setType('contact')
      setCenterCardDisabled(false)
      setRightCardDisabled(true)
    } else {
      throw new Error('Invalid type given')
    }

    if (newIsGuest !== undefined) {
      setIsGuest(newIsGuest)
      primaryPartyRecord.assertGuest = newIsGuest
    }

  }, [setType, setCenterCardDisabled, setRightCardDisabled, setIsGuest, primaryPartyRecord])

  useEffect(() => {
    if (isTypeLoaded || primaryPartyRecord?._has_user_account === undefined) {
      return
    }

    setIsTypeLoaded(true)

    primaryPartyRecord?._has_user_account
      ? activateType('user')
      : activateType('contact')

    primaryPartyRecord?.user?.allow_otp
      ? setIsGuest(true)
      : setIsGuest(false)

  }, [primaryPartyRecord, isTypeLoaded, activateType, setIsGuest])

  return (
    <DetailWrapper
      preserveEditDraft
      entityDisplayName={isUserType ? 'User' : 'Contact'}
      detailEditMode={detailEditMode}
      setDetailEditMode={setDetailEditMode}
      typeIdToDisplayName={typeIdToDisplayName}
      primaryDetailRecord={primaryPartyRecord}
      isLoading={!createMode && (loading || !isSuccess)}
      secondaryDataLoaderCallBack={fetchAuxiliaryRecords}
      upsertDetailCallback={upsertPartyCallback}
      bulkUpdateCallBack={bulkUpdateParties}
      finalAuxiliaryRecords={finalAuxiliaryRecords}
    >
      {({ formikProps, stageActivationChange, deleteEntityCallback }) => {
        return (
          <>
            <div style={{ float: 'left', width: '34%' }}>
              <LeftCard
                entityDisplayName={isUserType ? 'User' : 'Contact'}
                formikProps={formikProps}
                editMode={detailEditMode}
                typeIdToDisplayName={typeIdToDisplayName}
                deleteEntityCallback={
                  deleteEntityCallback(
                    isUserType ? removeUser : removeParty
                  )
                }
                activationChangeCallback={stageActivationChange(formikProps)}
                listOfTypes={resourceTypes}
                hideSuspend={type !== 'user'}
                arrayOfBucketConfig={finalAuxiliaryRecords?.primero}
              >
                {isUserType ? (
                  <UserLeftChild
                    formikProps={formikProps}
                    editMode={detailEditMode}
                    createMode={createMode}
                    activateType={activateType}
                    isGuest={isGuest}
                  />
                ) : (
                  <PeopleLeftChild
                    formikProps={formikProps}
                    editMode={detailEditMode}
                    createMode={createMode}
                    partyTypes={finalAuxiliaryRecords?.partyTypes}
                    jobTitles={finalAuxiliaryRecords?.jobTitles}
                    activateType={activateType}
                    isGuest={isGuest}
                  />
                )}
              </LeftCard>
            </div>
            <div style={{ float: 'left', width: '33%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.segundo}
                disabled={centerCardDisabled}
              />
            </div>
            <div style={{ float: 'right', width: '33%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.tercero}
                disabled={rightCardDisabled}
              />
            </div>
          </>
        )
      }}
    </DetailWrapper>
  )
}
export default UserDetail
